import { render, staticRenderFns } from "./about.vue?vue&type=template&id=be0a91aa&"
var script = {}
import style0 from "./about.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be0a91aa')) {
      api.createRecord('be0a91aa', component.options)
    } else {
      api.reload('be0a91aa', component.options)
    }
    module.hot.accept("./about.vue?vue&type=template&id=be0a91aa&", function () {
      api.rerender('be0a91aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/about/about.vue"
export default component.exports